import React, { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import HeroSection from './sections/HeroSection';
import ContactUsSection from './sections/ContactUsSection';
import BuySection from './sections/BuySection';
import WhyChooseUs from './sections/WhyChooseUs';
import SellSection from './sections/SellSection';
import RecentlyLaunchedSection from './sections/RecentlyLaunchedSection';
import { getRecentlyLaunchedAuctions } from './HomePageActions';

function HomePage() {
  const dispatch = useDispatch();
  const recentlyLaunchedAuctions = useSelector((state) =>
    state.homePage.get('recentlyLaunched'),
  );

  useEffect(() => {
    const { hash } = window.location;

    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getRecentlyLaunchedAuctions());
  }, [dispatch]);

  const showRecentlyLaunchedSection = useMemo(
    () => recentlyLaunchedAuctions?.length > 3,
    [recentlyLaunchedAuctions],
  );

  return (
    <div className="homepage">
      <div className="homepage__inner">
        <HeroSection />
        <WhyChooseUs recentlyLaunchedAuctionsExist={showRecentlyLaunchedSection} />
        {showRecentlyLaunchedSection && (
          <RecentlyLaunchedSection items={recentlyLaunchedAuctions} />
        )}
        <BuySection />
        <SellSection />
        <ContactUsSection />
      </div>
    </div>
  );
}

export default HomePage;
